import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import { Alert } from 'react-bootstrap';

export default function Errors({
  description = 'The following errors prevented the form from saving:',
  errors,
}) {
  return (
    <div>
      {errors && !isEmpty(errors) && (
        <Alert bsStyle="warning">
          {description}
          {errors.map(error => (
            <div key={error}>
              {error}
            </div>
          ))}
        </Alert>
      )}
    </div>
  );
}

Errors.propTypes = {
  description: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
};
